import {
  COUNT_APPROVE_WAITING_REQUESTS,
  FETCH_APPROVE_WAITING_REQUESTS,
  FETCH_CERTIFICATION_REQUESTS,
  FETCH_REQUEST
} from 'actions/types';

const countApproveWaiting = (action, state) => {
  if (!action.payload.data) return state;
  return { ...state, approveCount: action.payload.data.data.length };
};

const clearApproveCount = state => {
  return { ...state, approveCount: null };
};

export default function(state = null, action) {
  switch (action.type) {
    case COUNT_APPROVE_WAITING_REQUESTS:
    case FETCH_APPROVE_WAITING_REQUESTS:
      return countApproveWaiting(action, state);
    case FETCH_REQUEST:
    case FETCH_CERTIFICATION_REQUESTS:
      return clearApproveCount(state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/badges.js